import MiniGamesFilters from "../Filters/MiniGamesFilters";

export default class PersonalityQuizFilters extends MiniGamesFilters {
  personalityQuizIds?: string[] = null;

  constructor(filters: any) {
    super(filters);
    this.personalityQuizIds =
      filters && filters.personalityQuizIds ? filters.personalityQuizIds : null;
  }

  public constructMainFiltersUrl?() {
    let url = super.constructMainFiltersUrl();

    if (this.personalityQuizIds && this.personalityQuizIds.length > 0) {
      url += `&personality_quiz_ids=${this.personalityQuizIds.join(",")}`;
    }

    return url;
  }
}
